/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__instructions__error = /** @type {(inputs: {}) => string} */ () => {
	return `Die Navigationsanweisungen konnten nicht angezeigt werden.`
};

const en_route_details__instructions__error = /** @type {(inputs: {}) => string} */ () => {
	return `The navigation instructions couldn't be displayed.`
};

const es_route_details__instructions__error = /** @type {(inputs: {}) => string} */ () => {
	return `No se han podido mostrar las instrucciones de navegación.`
};

const fr_route_details__instructions__error = /** @type {(inputs: {}) => string} */ () => {
	return `Les instructions de navigation n’ont pas pu être affichées.`
};

const it_route_details__instructions__error = /** @type {(inputs: {}) => string} */ () => {
	return `Non è stato possibile visualizzare le istruzioni di navigazione.`
};

const nl_route_details__instructions__error = /** @type {(inputs: {}) => string} */ () => {
	return `De navigatie-instructies konden niet worden weergegeven.`
};

const pt_route_details__instructions__error = /** @type {(inputs: {}) => string} */ () => {
	return `Não foi possível visualizar as instruções de navegação.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions__error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__instructions__error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__instructions__error", locale)
	if (locale === "de") return de_route_details__instructions__error(inputs)
	if (locale === "en") return en_route_details__instructions__error(inputs)
	if (locale === "es") return es_route_details__instructions__error(inputs)
	if (locale === "fr") return fr_route_details__instructions__error(inputs)
	if (locale === "it") return it_route_details__instructions__error(inputs)
	if (locale === "nl") return nl_route_details__instructions__error(inputs)
	return pt_route_details__instructions__error(inputs)
};